import { JsonMimeType } from "@lib/ApiClient";
import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import {
    TokensResponse,
    TokensResponseSchema,
} from "@modules/authentication/schemas/TokensResponseSchema";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { create } from "superstruct";

import RefreshTokenServiceInterface from "../TokenManager/RefreshTokenServiceInterface";

export class RefreshTokenApiService implements RefreshTokenServiceInterface {
    public constructor(private readonly apiClient: ApiClientInterface) {}

    refreshToken(params: {
        currentToken: string;
        myshopifyDomain: string;
    }): Observable<TokensResponse> {
        return this.apiClient
            .post({
                url: "/auth/refresh",
                responseType: "json",
                contentType: JsonMimeType,
                body: JSON.stringify({
                    currentToken: params.currentToken,
                }),
                queryParams: {
                    shop: params.myshopifyDomain,
                },
            })
            .pipe(
                map((response) => {
                    return create(response.body, TokensResponseSchema);
                })
            );
    }
}
